import { Component, OnInit } from '@angular/core';
import { BirthdayListService } from '../../services/birthday-list.service';
import { PlayroomService } from '../../services/playroom.service';
import { CommonMethodesService } from '../../services/common-methodes.service';
import { Playroom } from '../../models/playroom.model';
import { CostumArray } from '../../models/customArray';
import { RoomArray } from '../../models/roomArray';

@Component({
  selector: 'app-prosecan-uzrast-deteta-igraonica-izvestaj',
  templateUrl: './prosecan-uzrast-deteta-igraonica-izvestaj.component.html',
  styleUrls: ['./prosecan-uzrast-deteta-igraonica-izvestaj.component.scss'],
})
export class ProsecanUzrastDetetaIgraonicaIzvestajComponent implements OnInit {
 paginationSettings = {
  totalItems: 0,
  itemsPerPage: 10,
  currentPage: 1
};

  visitorStats:any[]=[]
   roomBirthdayStats:any[]=[]
   loading = false;
   itemsPerPageLarge: number = 2147483647;
   playroom: Playroom[]
  userList: Array<CostumArray>;
  selectedUser: CostumArray | null = null
   roomList: Array<RoomArray>;
   selectedRoom: RoomArray | null = null
   cityQuery: string = ''
   roomNameQuery: string = '';
   birthdayZoneNameQuery: string = '';
   VisitorNameQuery: string = '';
   
   CallDateFromQuery: string = '';
   CallDateToQuery: string = '';
   AppointmentDateFromQuery: string = '';
   AppointmentDateToQuery: string = '';
    PricePerChildrenFromQuery:string=''
       PricePerChildrenToQuery:string=''
   
   PlannedChildNumberFromQuery: string = '';
   PlannedChildNumberToQuery: string = '';
   PresentChildNumberQuery: string = '';
   PresentChildNumberFromQuery: string = '';
   PresentChildNumberToQuery: string = '';
   TotalPricePaidQuery: string = '';
   TotalPricePaidFromQuery: string = '';
   TotalPricePaidToQuery: string = '';
   StatusCallQuery: string = '';
   NumberOfBirthdayFromQuery:string=''
   NumberOfBirthdayToQuery:string='';
   AdvancePaymentWillQuery:string='';
   AdvancePricePaidFromQuery:string='';
   AdvancePricePaidToQuery:string='';
   pageSize: number = 2147483647;
   lastVisitorSearch:string=''
   lastRoomSearch:string=""

  constructor(
private birthdayListService : BirthdayListService,
private roomService: PlayroomService,
private commonMethodsService: CommonMethodesService

  ) { }

  ngOnInit() {

 this.roomService.getAllPlayroomsSub().subscribe(data => {
      this.playroom = data;
      this.userList = this.commonMethodsService.mapPlayroomsToUserList(this.playroom);
    });
 this.LoadRoomAverageBirthdayReport(this.roomNameQuery)


  }


   onUserChange(event: any) {
    this.getReducedArray() 
    this.cityQuery = this.selectedUser.display
    console.log(" this.cityQuery on UserChange", this.cityQuery)
 
 
  }

  getReducedArray() {
    this.roomList = []

    var disp = this.selectedUser?.display
    console.log("Lista rodjendana Room - DISP", disp)

    this.roomList = this.commonMethodsService.mapPlayroomsToRoomList(this.playroom, disp);
    console.log("Lista rodjendana Room - RoomList", this.roomList)

  }

  onRoomChange(event: any) {


    console.log("SELEKTOVANI Igraonica", this.selectedRoom)
    this.commonMethodsService.getEmployeesByRoom(
      parseInt(this.selectedRoom.value),
      this.paginationSettings.currentPage,
      this.paginationSettings.itemsPerPage
    ).subscribe(employees => {
      console.log("EMP", employees);
    
    });
    this.cityQuery = '';
    this.roomNameQuery = this.selectedRoom.display;
  }


    loadBirthday(){
 this.StatusCallQuery = ''
    this.birthdayListService.getAllBirthday({
      currentPage: this.paginationSettings.currentPage, itemsPerPage: this.paginationSettings.itemsPerPage,
      cityQuery: this.cityQuery,
      roomNameQuery: this.roomNameQuery,
      birthdayZoneNameQuery: this.birthdayZoneNameQuery,
      VisitorNameQuery: this.VisitorNameQuery,      
      CallDateFromQuery: this.CallDateFromQuery,
      CallDateToQuery: this.CallDateToQuery,
      AppointmentDateFromQuery: this.AppointmentDateFromQuery,
      AppointmentDateToQuery: this.AppointmentDateToQuery,
      PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
      PricePerChildrenToQuery: this.PricePerChildrenToQuery,  
      PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
      PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
      PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
      PresentChildNumberToQuery: this.PresentChildNumberToQuery,
      TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
      TotalPricePaidToQuery: this.TotalPricePaidToQuery,
      StatusCallQuery: this.StatusCallQuery,
      NumberOfBirthdayFromQuery: this.NumberOfBirthdayFromQuery,
      NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
      AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
      AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
      AdvancePricePaidToQuery:this.AdvancePricePaidToQuery

    })


  }

async LoadRoomAverageBirthdayReport(Room?: string) {
  this.loading = true;
  this.birthdayListService
    .getReportByRoomAverageBirthday({

      roomNameQuery: Room
    })
    .subscribe(res => {
      console.log('SERVER RESPONSE Room', res);


      this.roomBirthdayStats = res.body ?? [];
      this.loading = false;

    });
}

blobToFile(data: any, type: string, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);
    a.href = url; a.download = fileName; a.click();
    window.URL.revokeObjectURL(url);
  }
BirthdayRoomAverageReportExportCSV() {
  this.birthdayListService
    .BirthdayRoomAverageReportExportCSV({
     
      roomNameQuery: this.roomNameQuery
    })
    .subscribe(response => {
      this.blobToFile(
        response,
        'text/csv;charset=utf-8;',
        'ProsecanUzrastDeteta.csv'
      );
    });
}
 async loadSearchResult() {
    this.birthdayListService.getAllBirthday(
      {
        currentPage: this.paginationSettings.currentPage,
        itemsPerPage: this.paginationSettings.itemsPerPage,
        cityQuery: this.cityQuery,
        roomNameQuery: this.roomNameQuery,
        birthdayZoneNameQuery: this.birthdayZoneNameQuery,
        VisitorNameQuery: this.VisitorNameQuery,       
        CallDateFromQuery: this.CallDateFromQuery,
        CallDateToQuery: this.CallDateToQuery,
        AppointmentDateFromQuery: this.AppointmentDateFromQuery,
        AppointmentDateToQuery: this.AppointmentDateToQuery,      
        PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
        PricePerChildrenToQuery: this.PricePerChildrenToQuery, 
        PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
        PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
        PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
        PresentChildNumberToQuery: this.PresentChildNumberToQuery,
        TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
        TotalPricePaidToQuery: this.TotalPricePaidToQuery,
        StatusCallQuery: this.StatusCallQuery,
        NumberOfBirthdayFromQuery:this.NumberOfBirthdayFromQuery,
        NumberOfBirthdayToQuery: this.NumberOfBirthdayToQuery,
        AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
        AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
        AdvancePricePaidToQuery:this.AdvancePricePaidToQuery
      })  

this.lastRoomSearch=this.roomNameQuery 
  await this.LoadRoomAverageBirthdayReport(this.lastRoomSearch)
  
  
    }

async resetFilters() {
    this.cityQuery = ''
    this.roomNameQuery = '';
   
  this.selectedUser  = null
    this.loadSearchResult() 
 await this.LoadRoomAverageBirthdayReport(this.lastRoomSearch)
  }
}